import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../util/varios";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTableScroll from "../useTableScrollcesar";
import { Table } from "@material-ui/core";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";

const TablaDeudaContribuyentes = (props) => {
  const headCells = [
    { label: "Año", textAlign: "center" },
    { label: "Mes", textAlign: "center" },
    { label: "Monto", textAlign: "center" },
    { label: "Interes Mora", textAlign: "center" },
    { label: "Recargo", textAlign: "center" },
    { label: "Multa", textAlign: "center" },
    { label: "Descuento", textAlign: "center" },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const [records, setRecords] = useState([]);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [totImpu, setTotImpu] = useState(0.0);
  const [totFact, setTotFact] = useState(0.0);
  const [totInt, setTotInt] = useState(0.0);
  const [totRec, setTotRec] = useState(0.0);
  const [totMulta, setTotMulta] = useState(0.0);
  const [deduci, setDeduci] = useState(0.0);

  useEffect(() => {
    if (props.factura) {
      if (
        props.factura.idcontribuyente === "0" ||
        props.factura.idcontribuyente === null
      ) {
        setTotImpu(props.factura.totalinmpuesto);
        setTotFact(props.factura.totalfactura);
        setTotInt(props.factura.totalinteres);
        setTotRec(props.factura.totalrecargo);
        setTotMulta(props.factura.totalmulta);
        setDeduci(props.factura.deducible);
      } else {
        setRecords(props.deuda);
        let impu = 0.0;
        let inte = 0.0;
        let reca = 0.0;
        let mult = 0.0;
        let totdeu = 0.0;
        for (let i = 0; i < props.deuda.length; i++) {
          impu = parseFloat(impu) + parseFloat(props.deuda[i].monto);
          inte = parseFloat(inte) + parseFloat(props.deuda[i].intereses);
          reca = parseFloat(reca) + parseFloat(props.deuda[i].recargo);
          mult = parseFloat(mult) + parseFloat(props.deuda[i].multa);
        }
        totdeu =
          impu + inte + reca + mult - parseFloat(props.factura.deducible);
        setTotImpu(impu);
        setTotFact(totdeu);
        setTotInt(inte);
        setTotRec(reca);
        setTotMulta(mult);
        setDeduci(props.factura.deducible);
      }
    }
  }, [props.factura]);

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  return (
    <div>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <div className="m-0">
        <TblContainer
          container={{
            height: 110,
            maxHeight: 180,
            width: "100%",
            overflow: "auto",
          }}
        >
          <TblHead />
          <TableBody>
            {records &&
              records.map((deu, index) => (
                <TableRow key={index}>
                  <TableCell className="p-0 text-center">{deu.anio}</TableCell>
                  <TableCell className="p-0 text-center">{deu.mes}</TableCell>
                  <TableCell className="p-0 text-end">
                    {formatMoneda(
                      deu.monto.replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                  </TableCell>
                  <TableCell className="p-0 text-end">
                    {formatMoneda(
                      deu.intereses.replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                  </TableCell>
                  <TableCell className="p-0 text-end">
                    {formatMoneda(
                      deu.recargo.replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                  </TableCell>
                  <TableCell className="p-0 text-end">
                    {formatMoneda(
                      deu.multa.replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                  </TableCell>
                  <TableCell className="p-0 text-end">
                    {formatMoneda(
                      deu.credito.replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </TblContainer>
      </div>
      <div
        className="row col-12 p-0 m-0 border-table"
        style={{ borderTopStyle: "hidden" }}
      >
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className="">
                <p style={{ fontWeight: "bold" }}>
                  {"Monto: " +
                    formatMoneda(
                      totImpu.toString().replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                </p>
              </TableCell>
              <TableCell className="">
                <p style={{ fontWeight: "bold" }}>
                  {"Interes: " +
                    formatMoneda(
                      totInt.toString().replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                </p>
              </TableCell>
              <TableCell className="">
                <p style={{ fontWeight: "bold" }}>
                  {"Multa: " +
                    formatMoneda(
                      totMulta.toString().replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                </p>
              </TableCell>
              <TableCell className="">
                <p style={{ fontWeight: "bold" }}>
                  {"Recargo: " +
                    formatMoneda(
                      totRec.toString().replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                </p>
              </TableCell>
              <TableCell className="">
                <p style={{ fontWeight: "bold" }}>Descuento: 0,00</p>
              </TableCell>
              <TableCell className="">
                <p style={{ fontWeight: "bold" }}>
                  {"Desct/Credito/Fiscal: " +
                    formatMoneda(
                      deduci.toString().replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                </p>
              </TableCell>
              <TableCell className="">
                <p style={{ fontWeight: "bold" }}>
                  {"Total: " +
                    formatMoneda(
                      totFact.toString().replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                </p>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
export default TablaDeudaContribuyentes;



// WEBPACK FOOTER //
// ./src/components/ingresos/tablaDeudaContribuyentes.js